import { logoIcon } from 'assets';
import { InputField } from 'components';
import { FormikProvider, useFormik } from 'formik';
import { Form, SubmitButton } from 'formik-antd';
import { FC, useEffect, useState } from 'react';
import { LoginRequest } from 'types';
import { useSelector } from 'react-redux';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { FormStyled } from './styles';
import { userData } from './selectors';
interface Props {
  onSubmit: (values: LoginRequest) => Promise<void>;
}

export const LoginForm: FC<Props> = ({ onSubmit }) => {
  const { error_message } = useSelector(userData);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const formik = useFormik<LoginRequest>({
    initialValues,
    async onSubmit(values) {
      setError('');
      localStorage.removeItem('login_error_message');
      try {
        await onSubmit(values);
      } catch (e) {
        setError('IDまたはパスワードが間違っています');
        formik.resetForm();
      }
    },
  });
  // エラーメッセージ取得
  useEffect(() => {
    const msg = localStorage.getItem('login_error_message');
    console.log('login_error_message on LoginForm mount:', msg);
    if (msg) {
      setError(msg);
    }
  }, []);

  return (
    <FormStyled>
      <div className="logo">
        <img src={logoIcon} alt="logo" />
      </div>
      <FormikProvider value={formik}>
        <Form layout="vertical" className="form">
          {(error || error_message) && <p className="error-message">{error || error_message}</p>}
          <Form.Item className="input-username" label="ID" colon={false} name="username">
            <InputField bordered={false} placeholder="IDを入力" name="username" />
          </Form.Item>
          <Form.Item label="パスワード" colon={false} name="password">
            <InputField
              bordered={false}
              placeholder="パスワードを入力"
              name="password"
              type={showPassword ? 'text' : 'password'}
              suffix={
                showPassword ? (
                  <EyeOutlined
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={{ cursor: 'pointer' }}
                  />
                ) : (
                  <EyeInvisibleOutlined
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={{ cursor: 'pointer', transform: 'scaleX(-1)' }}
                  />
                )
              }
            />
          </Form.Item>
          <SubmitButton
            className="btn-submit"
            disabled={!formik.values.password || !formik.values.username}
          >
            ログイン
          </SubmitButton>
        </Form>
      </FormikProvider>
    </FormStyled>
  );
};

const initialValues: LoginRequest = {
  username: '',
  password: '',
};
